import type { CheckInEvent, DerivedCheckInStatus } from './types';

export function deriveCheckInStatus(events: CheckInEvent[]): DerivedCheckInStatus {
	const voided = new Set<string>();
	for (const e of events) {
		if (e.voidsClientId) voided.add(e.voidsClientId);
	}

	const effective = events.filter((e) => !e.voidsClientId && !voided.has(e.clientId));
	if (effective.length === 0) return { status: 'none', lastEvent: null };

	const sorted = [...effective].sort((a, b) => {
		if (a.occurredAt !== b.occurredAt) return a.occurredAt < b.occurredAt ? -1 : 1;
		const ac = a.createdAt ?? '';
		const bc = b.createdAt ?? '';
		return ac < bc ? -1 : ac > bc ? 1 : 0;
	});

	const lastEvent = sorted[sorted.length - 1]!;
	return { status: lastEvent.direction, lastEvent };
}
